export const dealPageQueryKeys = {
  all: ['cruise-deal-pages'] as const,
  lists: () => [...dealPageQueryKeys.all, 'list'] as const,
  details: () => [...dealPageQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...dealPageQueryKeys.details(), id] as const,
};
